import { notificationsSelector } from '@onhandtech/onhand-fe-shared/lib/notifications'
import { NotificationGroup } from '@onhandtech/onhand-toolkit'
import { useSelector } from 'react-redux'
import { Outlet } from 'react-router-dom'

import * as CSS from './auth-layout.styles'

const AuthLayout = () => {
  const notifications = useSelector(notificationsSelector)

  return (
    <CSS.AuthLayout data-testid="layout--auth">
      <NotificationGroup notifications={notifications} />
      <CSS.LeftPanel>
        <CSS.Logo alt="ODIN" src="/static/img/logo_tagline.svg" />
      </CSS.LeftPanel>
      <CSS.RightPanel>
        <Outlet />
      </CSS.RightPanel>
    </CSS.AuthLayout>
  )
}

export default AuthLayout
